import React, { useState } from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  checkboxStyle: {
    cursor: 'pointer',
    padding: '0px 5px',
    '&:hover': {
      backgroundColor: `${theme.palette.primary.main}47`,
      borderRadius: '3px'
    }
  },
  root: {
    padding: '3px 0px'
  },
  textColor: {
    color: theme.palette.primary.main
  }
}));

const PortfolioManagersGroupByCheckbox = ({ title, checked, onChange, ...rest }) => {
  const classes = useStyles();
  const [isChecked, setIsChecked] = useState(checked);

  const handleCheckboxClick = () => {
    if (isChecked) {
      onChange('Share Class');
    } else {
      onChange('Holding');
    }
    setIsChecked(prevState => !prevState);
  };

  return (
    <Box
      bgcolor="transparent"
      width="100%"
      display="flex"
      alignItems="center"
      onClick={handleCheckboxClick}
      className={classes.checkboxStyle}
    >
      <Checkbox
        checked={isChecked}
        value={isChecked}
        color="primary"
        classes={{ root: classes.root }}
        {...rest}
      />
      <Typography
        variant="subtitle1"
        component="p"
        color={isChecked ? 'primary' : 'textPrimary'}
        style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {title}
      </Typography>
    </Box>
  );
};

PortfolioManagersGroupByCheckbox.propTypes = {
  title: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default PortfolioManagersGroupByCheckbox;
